module.exports = __webpack_public_path__ + "img/IngoKoch_140x140_rund.c7866c80.jpg";